module.exports = __webpack_public_path__ + "img/building_zhinenghua.56af57c2.png";